import axios from "axios";
import { urlCoreBack } from "../../project/configs/config";
import '../utils/axios.interceptor';
//
// #############################################################################
//
export const getPrecioLenteDeContacto = async (params) => {
	let _params = {};
	let _errorMessage =
		"Se produjo un error al obtener el precio de la Lente de Contacto";

	_params.esfera = params.lenteContactoEsfera;
	_params.cilindro = params.lenteContactoCilindro;
	_params.eje = params.lenteContactoEje;
	_params.id_lc_curva = params.lenteContactoCurvaBase;
	_params.id_lc_diametro = params.lenteContactoDiametro;
	_params.id_lente_contacto_producto = params.lenteContactoProducto;
	_params.id_lc_presentacion = params.lenteContactoPresentacion;

	try {
		const response = await axios({
			method: "GET",
			url: `${urlCoreBack}v1/lente-contacto-precio/`,
			params: _params,
		});

		if (response.status === 200) {
			let _error = "status" in response.data && response.data.status === "error";
			if (!_error) {
				// si no hay error controlado
				response.ok = true;
				return response;
			} else {
				if (
					response.data.code ===
					"err-lente-contacto-precio-lc-precio-not-exist"
				) {
					response.ok = false;
					response.messageText = "No existe precio para la Lente de Contacto";
					response.messageSeverity = "info";
					return response;
				}
			}
		}

		// si hay algun error controlado

		console.log(_errorMessage);
		console.log(response);

		response.ok = false;
		response.messageText = _errorMessage;
		response.messageSeverity = "error";
		return response;
	} catch (error) {
		console.log(_errorMessage);
		if (error.response) {
			// The request was made and the server responded with a status code that falls out of the range of 2xx
			console.log(error.response);
		} else if (error.request) {
			// The request was made but no response was received
			// `error.request` is an instance of XMLHttpRequest in the browser and an instance of
			// http.ClientRequest in node.js
			console.log(error.request);
		} else {
			// Something happened in setting up the request that triggered an Error
			console.log(error);
		}
		let response = {};
		response.ok = false;
		response.messageText = _errorMessage;
		response.messageSeverity = "error";
		return response;
	}
};
//
// #############################################################################
//
// export const getListasPreciosLentesDeContacto = async (params) => {
// 	let _params = {};
// 	let _errorMessage =
// 		"Se produjo un error al obtener las Listas de precios de las Lentes de Contacto";

// 	if (params.lenteContactoMarca) {
// 		_params.id_lc_marca = params.lenteContactoMarca;
// 	}

// 	if (params.lenteContactoSubMarca) {
// 		_params.id_lc_submarca = params.lenteContactoSubMarca;
// 	}

// 	if (params.lenteContactoTiempoUso) {
// 		_params.id_lc_tiempo_uso = params.lenteContactoTiempoUso;
// 	}

// 	if (params.lenteContactoTipo) {
// 		_params.id_lc_tipo = params.lenteContactoTipo;
// 	}

// 	if (params.lenteContactoMaterial) {
// 		_params.id_lc_material = params.lenteContactoMaterial;
// 	}

// 	if (params.lenteContactoProducto) {
// 		_params.id_lente_contacto_producto = params.lenteContactoProducto;
// 	}

// 	if (params.lenteContactoColor) {
// 		_params.id_lc_color = params.lenteContactoColor;
// 	}

// 	if (params.disponibleObraSocial) {
// 		_params.disponible_obra_social = params.disponibleObraSocial;
// 	}

// 	if ("precioVentaDesde" in params) {
// 		_params.precio_venta_desde = params.precioVentaDesde;
// 	}

// 	if ("precioVentaHasta" in params) {
// 		_params.precio_venta_hasta = params.precioVentaHasta;
// 	}

// 	if (params.rows !== undefined) {
// 		_params.rows = params.rows;
// 	}

// 	if (params.first !== undefined) {
// 		_params.first = params.first;
// 	}

// 	try {
// 		const response = await axios({
// 			method: "GET",
// 			url: `${urlCoreBack}v1/lente-contacto-listas-precio/`,
// 			params: _params,
// 		});

// 		if (response.status === 200) {
// 			let _error = "status" in response.data && response.data.status === "error";
// 			if (!_error) {
// 				// si no hay error controlado
// 				response.ok = true;
// 				return response;
// 			} else {
// 				if (
// 					response.data.code ===
// 					"err-lente-contacto-precio-lc-precio-not-exist"
// 				) {
// 					response.ok = false;
// 					response.messageText =
// 						"No existen listas de precios con los atributos dados";
// 					response.messageSeverity = "info";
// 					return response;
// 				}
// 			}
// 		}

// 		// si hay algun error controlado

// 		console.log(_errorMessage);
// 		console.log(response);

// 		response.ok = false;
// 		response.messageText = _errorMessage;
// 		response.messageSeverity = "error";
// 		return response;
// 	} catch (error) {
// 		console.log(_errorMessage);
// 		if (error.response) {
// 			// The request was made and the server responded with a status code that falls out of the range of 2xx
// 			console.log(error.response);
// 		} else if (error.request) {
// 			// The request was made but no response was received
// 			// `error.request` is an instance of XMLHttpRequest in the browser and an instance of
// 			// http.ClientRequest in node.js
// 			console.log(error.request);
// 		} else {
// 			// Something happened in setting up the request that triggered an Error
// 			console.log(error);
// 		}
// 		let response = {};
// 		response.ok = false;
// 		response.messageText = _errorMessage;
// 		response.messageSeverity = "error";
// 		return response;
// 	}
// };
//
// #############################################################################
//
export const getLPLentesDeContacto = async (params) => {
	let _params = {};
	let _errorMessage =
		"Se produjo un error al obtener las Listas de precios de las Lentes de Contacto";

	if (params.lenteContactoMarca) {
		_params.id_lc_marca = params.lenteContactoMarca;
	}

	if (params.lenteContactoSubMarca) {
		_params.id_lc_submarca = params.lenteContactoSubMarca;
	}

	if (params.lenteContactoTiempoUso) {
		_params.id_lc_tiempo_uso = params.lenteContactoTiempoUso;
	}

	if (params.lenteContactoTipo) {
		_params.id_lc_tipo = params.lenteContactoTipo;
	}

	if (params.lenteContactoMaterial) {
		_params.id_lc_material = params.lenteContactoMaterial;
	}

	if (params.lenteContactoDiagnostico) {
		_params.id_lc_diagnostico = params.lenteContactoDiagnostico;
	}

	if (params.lenteContactoProducto) {
		_params.id_lente_contacto_producto = params.lenteContactoProducto;
	}

	if (params.lenteContactoColor) {
		_params.id_lc_color = params.lenteContactoColor;
	}

	if (params.disponibleObraSocial) {
		_params.disponible_obra_social = params.disponibleObraSocial;
	}

	if (params.rows !== undefined) {
		_params.rows = params.rows;
	}

	if (params.first !== undefined) {
		_params.first = params.first;
	}

	try {
		const response = await axios({
			method: "GET",
			url: `${urlCoreBack}v1/lente-contacto-listas-precio/`,
			params: _params,
		});

		if (response.status === 200) {
			let _error = "status" in response.data && response.data.status === "error";
			if (!_error) {
				// si no hay error controlado
				response.ok = true;
				return response;
			} else {
				if (
					response.data.code ===
					"err-lente-contacto-precio-lc-precio-not-exist"
				) {
					response.ok = false;
					response.messageText = "No existen listas de precios con los atributos dados";
					response.messageSeverity = "info";
					return response;
				}
			}
		}

		// si hay algun error controlado

		console.log(_errorMessage);
		console.log(response);

		response.ok = false;
		response.messageText = _errorMessage;
		response.messageSeverity = "error";
		return response;
	} catch (error) {
		console.log(_errorMessage);
		if (error.response) {
			// The request was made and the server responded with a status code that falls out of the range of 2xx
			console.log(error.response);
		} else if (error.request) {
			// The request was made but no response was received
			// `error.request` is an instance of XMLHttpRequest in the browser and an instance of
			// http.ClientRequest in node.js
			console.log(error.request);
		} else {
			// Something happened in setting up the request that triggered an Error
			console.log(error);
		}
		let response = {};
		response.ok = false;
		response.messageText = _errorMessage;
		response.messageSeverity = "error";
		return response;
	}
};
//
// #############################################################################
//
export const getLPLenteDeContacto = async (params) => {
	let _params = {};
	let _errorMessage =
		"Se produjo un error al obtener la Listas de precios de Lentes de Contacto";

	_params.id = params;

	try {
		const response = await axios({
			method: "GET",
			url: `${urlCoreBack}v1/lc-lista-precio/`,
			params: _params,
		});

		if (response.status === 200) {
			let _error = "status" in response.data && response.data.status === "error";
			if (!_error) {
				// si no hay error controlado
				response.ok = true;
				return response;
			} else {
				if (
					response.data.code ===
					"err-lente-contacto-precio-lc-precio-not-exist"
				) {
					response.ok = false;
					response.messageText = "No existen listas de precios con los atributos dados";
					response.messageSeverity = "info";
					return response;
				}
			}
		}

		// si hay algun error controlado

		console.log(_errorMessage);
		console.log(response);

		response.ok = false;
		response.messageText = _errorMessage;
		response.messageSeverity = "error";
		return response;
	} catch (error) {
		console.log(_errorMessage);
		if (error.response) {
			// The request was made and the server responded with a status code that falls out of the range of 2xx
			console.log(error.response);
		} else if (error.request) {
			// The request was made but no response was received
			// `error.request` is an instance of XMLHttpRequest in the browser and an instance of
			// http.ClientRequest in node.js
			console.log(error.request);
		} else {
			// Something happened in setting up the request that triggered an Error
			console.log(error);
		}
		let response = {};
		response.ok = false;
		response.messageText = _errorMessage;
		response.messageSeverity = "error";
		return response;
	}
};
//
// #############################################################################
//
export const getListaPrecioLentesDeContactoRango = async (params) => {
	let _params = {};
	let _errorMessage =
		"Se produjo un error al obtener el rango de la Lista de Precios de la Lente de Contacto";

	_params.id = params.idListaPrecioRango;

	try {
		const response = await axios({
			method: "GET",
			url: `${urlCoreBack}v1/lente-contacto-lista-precio-rango/`,
			params: _params,
		});

		if (response.status === 200) {
			let _error = "status" in response.data && response.data.status === "error";
			if (!_error) {
				// si no hay error controlado
				response.ok = true;
			} else {
				switch (response.data.error_code) {
					case "err-lente-contacto-precio-rango-not-exist":
						response.ok = false;
						response.messageText =
							"No existe el rango de precios para la Lente de Contacto";
						response.messageSeverity = "info";
						break;
					case "err-lente-contacto-precio-rango-lista-precio-not-enabled":
						response.ok = false;
						response.messageText =
							"La Lista de Precios ya no se encuentra habilitada";
						response.messageSeverity = "info";
						break;
					case "err-lente-contacto-precio-rango-lista-precio-not-referencia":
						response.ok = false;
						response.messageText = "La Lista de Precios ya no es de referencia";
						response.messageSeverity = "info";
						break;
					default:
						break;
				}
			}
			return response;
		}

		// si hay algun error controlado

		console.log(_errorMessage);
		console.log(response);

		response.ok = false;
		response.messageText = _errorMessage;
		response.messageSeverity = "error";
		return response;
	} catch (error) {
		console.log(_errorMessage);
		if (error.response) {
			// The request was made and the server responded with a status code that falls out of the range of 2xx
			console.log(error.response);
		} else if (error.request) {
			// The request was made but no response was received
			// `error.request` is an instance of XMLHttpRequest in the browser and an instance of
			// http.ClientRequest in node.js
			console.log(error.request);
		} else {
			// Something happened in setting up the request that triggered an Error
			console.log(error);
		}
		let response = {};
		response.ok = false;
		response.messageText = _errorMessage;
		response.messageSeverity = "error";
		return response;
	}
};
